import { User } from "@app/common/types";
import { sendEvent } from "@app/utils/tracking/Tracker";

export const deleteAccount = sendEvent<{
  userId: User["id"];
  reason: string;
  comments: string;
}>("delete_account");

export const pageNotFound = sendEvent<{ attempted_url: string }>(
  "page_not_found"
);
